import { ActionButton, SimpleText, XStack, YStack, DropDownPickerView, Input } from '@my/ui'
import { PopupModal } from '../../../../components/index'
import { color } from '@my/util'
import { useState } from 'react'

// Modal to Add Tip
export const TipModal = ({
  isOpen,
  onClose,
  organizeIn,
  setOrganizeIn,
}: {
  isOpen: boolean
  onClose: () => void
  organizeIn: string
  setOrganizeIn: React.Dispatch<React.SetStateAction<string>>
}) => {
  const [priority, setPriority] = useState<string>('')
  const scenarioItems = [
    { label: 'Month-End Goal', value: 'Month-End Goal' },
    { label: 'Quarter-End Goal', value: 'Quarter-End Goal' },
    { label: 'Year-End goal', value: 'Year-End goal' },
  ]

  return (
    <PopupModal isOpen={isOpen} onClose={onClose} heading={'Add Tip To Goals'}>
      <YStack paddingHorizontal={'$2'} gap={20} mb={'$4'}>
        <TipDescription />
        <GoalOrganization
          items={scenarioItems}
          selectedValue={organizeIn}
          onValueChange={setOrganizeIn}
        />
        <PrioritySelection value={priority} setValue={setPriority} />
        <TargetAmountInput />
        <ActionButtons onClose={onClose} />
      </YStack>
    </PopupModal>
  )
}

// Tip Description Section
const TipDescription = () => (
  <SimpleText color={color.lightGreen} fontWeight={'700'} fontSize={18} marginVertical={'$4'}>
    Tip: "Increase savings by automating transfers"
  </SimpleText>
)

// Goal Organization Section
const GoalOrganization = ({
  items,
  selectedValue,
  onValueChange,
}: {
  items: { label: string; value: string }[]
  selectedValue: string
  onValueChange: (value: string) => void
}) => (
  <YStack gap={10} zIndex={10}>
    <SimpleText color={color.grey} fontWeight={'600'} fontSize={16}>
      Organize into
    </SimpleText>
    <DropDownPickerView
      items={items}
      iconSize={16}
      setValue={onValueChange}
      value={selectedValue}
      placeholder="Select List of Goals"
    />
  </YStack>
)

// Priority Selection Section
const PrioritySelection = ({
  value,
  setValue,
}: {
  value: string
  setValue: React.Dispatch<React.SetStateAction<string>>
}) => (
  <YStack gap={10}>
    <SimpleText color={color.grey} fontWeight={'600'} fontSize={16}>
      Priority Level
    </SimpleText>
    <PriorityButtons value={value} setValue={setValue} />
  </YStack>
)

// Render priority buttons for selecting goal priority
const PriorityButtons = ({
  value,
  setValue,
}: {
  value: string
  setValue: React.Dispatch<React.SetStateAction<string>>
}) => (
  <XStack gap={5}>
    {PRIORITIES.map((priority) => (
      <ActionButton
        key={priority}
        unstyled
        width={88}
        height={34}
        alignItems="center"
        borderRadius={4}
        justifyContent="center"
        bg={value === priority ? color.tzaGreen : color.dullGrey}
        onPress={() => setValue(priority)}
      >
        <SimpleText fontSize={14} color={value === priority ? color.white : color.black}>
          {priority}
        </SimpleText>
      </ActionButton>
    ))}
  </XStack>
)

const PRIORITIES = ['High', 'Medium', 'Low']

// Target Amount Input Section
const TargetAmountInput = () => (
  <YStack gap={10}>
    <SimpleText color={color.grey} fontWeight={'600'} fontSize={16}>
      Set Target Amount
    </SimpleText>
    <YStack borderColor={color.dullGrey} borderWidth={1} paddingVertical={8} paddingHorizontal={5}>
      <Input
        unstyled
        placeholder="Amount"
        placeholderTextColor={color.opaqueGrey}
        style={{ fontSize: 14, color: color.black }}
      />
    </YStack>
  </YStack>
)

// Action Buttons Section
const ActionButtons = ({ onClose }: { onClose: () => void }) => (
  <XStack gap={15}>
    <ActionButton
      width={'$10'}
      borderRadius={100}
      backgroundColor={color.tzaGreen}
      color={'$background'}
      fontSize={17}
      fontWeight={'700'}
    >
      Save
    </ActionButton>
    <ActionButton
      width={'$10'}
      borderRadius={100}
      backgroundColor={'white'}
      borderWidth={1}
      borderColor={color.opaqueGrey}
      color={color.black}
      fontSize={17}
      fontWeight={'700'}
      onPress={onClose}
    >
      Cancel
    </ActionButton>
  </XStack>
)
